export function checkIsShowInfoError(error): boolean {
    return error.message.indexOf('CheckUserAccessToMo') >= 0 && error.errorType === 199;
}
